

import React from 'react'
import { ImagePath } from '../../../assets/ImagePath';
import CachedImage from '../../common/CachedImage';

export const DotsLoader = () => {
    return (
        <div className="loader-ons w-full h-[90vh] flex items-center justify-center absolute top-0 left-0 z-10 ">
            {/* <img
                className="w-16"
                src={ImagePath.dotLoaderGif}
                alt="Onship || Images(svg, jpg, png"
            /> */}

            <CachedImage
                image="/img/Loft_loading.gif"
                imgKey="threeDotsLoader"
                className="w-16"
                alt="Onship || Images(svg, jpg, png"
            />
        </div>
    )
};
